import axios, { type InternalAxiosRequestConfig } from 'axios';
import type { ApiResponse, User } from '../types';

const api = axios.create({ baseURL: import.meta.env.VITE_API_BASE_URL ?? '/api', withCredentials: true, headers: { 'Content-Type': 'application/json' } });
let accessToken: string | null = null;
let refreshPromise: Promise<string | null> | null = null;

function cookie(name: string): string | undefined { return document.cookie.split('; ').find((part) => part.startsWith(`${name}=`))?.split('=')[1]; }
export function setAccessToken(token: string | null): void { accessToken = token; }

api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`;
  if (['post', 'put', 'patch', 'delete'].includes(config.method ?? '') && cookie('csrf')) config.headers['X-CSRF-Token'] = decodeURIComponent(cookie('csrf')!);
  return config;
});

api.interceptors.response.use((response) => response, async (error) => {
  const original = error.config as InternalAxiosRequestConfig & { _retried?: boolean };
  if (error.response?.status !== 401 || original?._retried || original?.url?.includes('/auth/refresh')) return Promise.reject(error);
  original._retried = true;
  refreshPromise ??= api.post<ApiResponse<{ accessToken: string; user: User }>>('/auth/refresh').then((response) => { setAccessToken(response.data.data.accessToken); return response.data.data.accessToken; }).catch(() => { setAccessToken(null); return null; }).finally(() => { refreshPromise = null; });
  const token = await refreshPromise;
  if (!token) return Promise.reject(error);
  original.headers.Authorization = `Bearer ${token}`;
  return api.request(original);
});

export default api;
